import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/mendeley': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M624.6 325.2c23.1 22.7 17.8 73.5 0 88.3-36.2 38.9-100 18.2-104.9-35.2-1-11.7 1.1-23 5.7-33 47.3-103.7-185.9-106.1-146.5-8.2 0.1 0.1 0.2 0.2 0.3 0.4 26.6 42.6-6.7 97.3-58.8 95.2-52 2.2-85.6-52.4-58.8-95.2 0.1-0.2 0.2-0.3 0.3-0.4 39.4-97.9-193.8-95.5-146.5 8.2 20.4 44.9-14.1 93.7-61.2 87.8-61.9-7.8-62.5-82.9-42.6-102.6 16-16 31.8-24.8 53-22.5 43.3-1 49.7-34.9 37.5-98.8-22.7-57.5 14.5-131.6 87.4-130.8 76.9 0.7 82.8 82 130.9 82 49.2 0 53.5-81.3 130.9-82 72.5-0.7 110.2 73.3 87.4 130.8-12.2 63.9-5.8 97.8 37.5 98.8 18.7-2 36.1 4.8 48.4 17.2zM320.7 306.1c43.6 0 62.8-37.8 62.8-62.8 0-34.7-28.1-62.8-62.8-62.8h-0.6c-34.6 0-62.8 28.1-62.8 62.8 0 25.3 19.4 62.8 62.8 62.8h0.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/mendeley.js
// module id = 932
// module chunks = 0